import { styled } from 'baseui'

export const StyledPaginatorWrapper = styled('div', ({ $theme }) => ({
  margin: '1.25rem 0',
  display: 'flex',
  justifyContent: 'center',
  flexWrap: 'wrap',
  background: $theme.colors.white,
  borderRadius: '0.5rem',
  padding: '0.5rem 1rem',
  boxShadow: $theme.lighting.shadowCard,
}));

export const StyledPageButton = styled('button', ({ $theme, $active }) => ({
  margin: '0 0.1875rem',
  fontWeight: $active ? 'bold' : 'normal',
  background: $active ? $theme.colors.highlightYellow : $theme.colors.white,
  border: `1px solid ${$theme.colors.borderFallback}`,
  borderRadius: '0.1875rem',
  padding: '0.1875rem 0.625rem',
  minWidth: '1.875rem',
  cursor: $active ? 'default' : 'pointer',
  transition: 'background 0.13s',
  opacity: 1,
  ':hover': {
    background: $active ? $theme.colors.highlightYellow : $theme.colors.bgInactive
  },
  ':disabled': {
    opacity: 0.6,
    cursor: 'default'
  }
}));

export const StyledDots = styled('span', ({ $theme }) => ({
  margin: '0 0.25rem',
  userSelect: 'none',
  color: $theme.colors.textLight,
  fontSize: '1.2em',
}));
